import { canDownloadSpaceFile, SpaceKind } from 'shared';

import { TreeSpaceRef } from '../types/data-room.types';
import { useRecipientRooms } from './use-recipient-rooms.hook';
import { DataRoomViewer, useDataRoomViewer } from './use-recipient-view.hook';

/**
 * Whether the person in front of us may take this file away, as opposed to only look at it.
 *
 * Asked here rather than carried in by whoever opened the viewer: the viewer is opened from six
 * places, and a permission passed along six paths is a permission that will be wrong on one of
 * them. The owner's side has both rights by definition; a recipient's right is the grant on the
 * room, and the server refuses the download route on the same rule whatever this returns.
 *
 * False while the session is still answering: a control that appears and then vanishes is worse
 * than one that arrives a moment late.
 */
export const useCanDownloadSpace = (space: null | TreeSpaceRef): boolean => {
  const viewer = useDataRoomViewer();
  const { rooms } = useRecipientRooms({ enabled: viewer === DataRoomViewer.RECIPIENT });

  if (viewer === DataRoomViewer.UNRESOLVED) return false;
  if (viewer === DataRoomViewer.OWNER) return true;
  if (!space || space.kind !== SpaceKind.DATA_ROOM) return false;

  const room = rooms.find(({ id }) => id === space.id);

  return room ? canDownloadSpaceFile(room.permission) : false;
};
